(function($) {
    $(document).ready(function() {
        $('.tr__block .carousel .item a').addClass('lightbox lightbox--image lightbox--single');

        $('.lightbox.lightbox--image.lightbox--single').magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            image: {
                verticalFit: true
            },
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1]
            }
        });
    });
})(jQuery);
